import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import {CommonModule} from '@angular/common';
import {
  TuiButtonModule,
  TuiErrorModule,
  TuiSvgModule,
  TuiLoaderModule,
  TuiDataListModule,
  TuiAlertService
} from '@taiga-ui/core';
import {
  TuiComboBoxModule,
  TUI_VALIDATION_ERRORS
} from "@taiga-ui/kit";
import { TuiInputModule, TuiSelectModule, TuiTextAreaModule, TuiDataListWrapperModule,TuiFieldErrorPipeModule } from '@taiga-ui/kit';
import { TuiTextfieldControllerModule} from "@taiga-ui/core";
import {SETTINGS} from "../../../core/config/common.settings";
import {AnnouncementService} from "../../../core/services/announcement.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-add-announcement',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TuiButtonModule,
    TuiErrorModule,
    TuiInputModule,
    TuiSelectModule,
    TuiTextAreaModule,
    TuiDataListWrapperModule,
    TuiSvgModule,
    TuiLoaderModule,
    TuiFieldErrorPipeModule,
    TuiTextfieldControllerModule,
    TuiDataListModule,
    TuiComboBoxModule,
    
  ],
  providers: [
    AnnouncementService,
    {
          provide: TUI_VALIDATION_ERRORS,
          useValue: {
          required: 'Required',
          },
    },
  ],
  templateUrl: './add-announcement.component.html',
  styleUrls: ['./add-announcement.component.scss']
})
export class AddAnnouncementComponent implements OnInit {
  announcementForm!: FormGroup;
  isLoading = false;

  recipientOptions: { label: string, value: string }[] = SETTINGS.ANNOUNCEMENT_RECIPIENT

  constructor(private fb: FormBuilder,
              private announcementService: AnnouncementService,
              private readonly alerts: TuiAlertService,
              private router: Router,) {}

  ngOnInit(): void {
    this.announcementForm = this.fb.group({
      subject: ['', Validators.compose([Validators.required])],
      recipient: ['', Validators.compose([Validators.required])],
      message: ['', Validators.compose([Validators.required,Validators.minLength(10)])]
    });
  }

  async onSubmit(): Promise<void> {
    if (this.announcementForm.valid) {
      this.isLoading = true;
      const formData = this.announcementForm.getRawValue();
      formData.recipient = formData.recipient.value
      try {
        await this.announcementService.createAnnouncement(formData)
        this.isLoading = false;
        this.alerts.open('<p style="color: red">Announcement Added Successfully</p>').subscribe();
        this.navigateToView()
      } catch (e: any) {
        this.isLoading = false;
        this.alerts.open(`<p style="color: red">${e.message}</p>`, { status: 'error' }).subscribe();
      }
    } else {
      // Mark all fields as touched to display validation errors
      this.announcementForm.markAllAsTouched();
    }
  }
  // protected stringify(items: readonly { label: string, value: string }[]) {
  //   const map = new Map(items.map(({label, value}) => [label, value] as [string, string]));
  //
  //   return ({$implicit}: TuiLetContext<string>) => map.get($implicit) || '';
  // }
  // protected stringify(items: readonly Python[]): TuiStringHandler<TuiContext<number>> {
  //   const map = new Map(items.map(({id, name}) => [id, name] as [number, string]));
  //
  //   return ({$implicit}: TuiContext<number>) => map.get($implicit) || '';
  // }

  cancel(): void {
    this.resetForm();
    this.navigateToView()
  }

  private resetForm(): void {
    this.announcementForm.reset();
  }

  navigateToView(): void {
    this.router.navigate(['admin/announcements'])
    // this.location.back();
  }
}
